import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import usePostData from "../../../CustomHooks/useAxios/usePostData";
import MainPageLayout from "../../../layout/MainPageLayout";
import { prepareFormData } from "../../../functions/prepareFormData";
import { ADD_VEHICLE } from "../../../api/allApi_List";
import AddVehicleForm from "../forms/AddVehicleForm";

const AddVehiclePage = () => {
  const { executePost, loading, formError, successResponse, setFormError } =
    usePostData();

  const sendData = async (formValues, reset) => {
    // send data into form data
    const formData = prepareFormData(formValues);
    //API calling
    executePost(formData, ADD_VEHICLE, reset);
  };
  return (
    <MainPageLayout headerConfig={{ title: "Add Vehicle" }}>
      <AddVehicleForm
        loading={loading}
        sendData={sendData}
        successResponse={successResponse}
      />
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};

export default AddVehiclePage;
